export default {
    "/": {
        "title": "Taoify - Plattform zum Aufbau von unabhängigen E-Commerce-Websites | Chinesische Produkte, weltweit verkaufen",
        "desc": "Taoify kombiniert Website-Erstellung, Übersetzung, Produktupload, Logistik, Zahlungen und Marketing in einem Dashboard: 18 KI-Assistenten helfen dir, 20 Sprachen für den globalen Verkauf deiner chinesischen Produkte."
    },
    "/feature": {
        "title": "Funktionen · Alles, was du zum Starten eines Shops brauchst, auf einer Seite · Taoify",
        "desc": "Website-Erstellung, Übersetzung, Produktupload, Versand, Zahlungen und Kundenakquise – Taoify bietet 15 Module in einem Dashboard, sodass du nicht mehr verschiedene Tools zusammenstellen musst."
    },
    "/ai-staff": {
        "title": "KI-Assistenten · 18 KI-Assistenten, die am meisten im Bereich Traffic beschäftigt sind · Taoify",
        "desc": "Von den 18 KI-Assistenten konzentrieren sich 5 auf das Wachstumsteam, um das Problem „keine Besucher“ zu lösen: 12 Shop-Checks, 30-tägige Marketingpläne, ein Produkt in 9 Kanälen optimiert, automatische Marketing-E-Mails, um ehemalige Käufer zurückzuholen."
    },
    "/logistics": {
        "title": "Kreuzgrenzlogistik · Von deinen Händen in die des Kunden · Taoify",
        "desc": "Erste Meile, Zollabwicklung, Haupttransport und Endlieferung, drei Routen nach Güterart und Zeitbedarf. YunExpress, Yanwen und 4PX sind angeschlossen, Lieferscheine, Tracking und Abweichungsmanagement in einem Dashboard."
    },
    "/payment": {
        "title": "Zahlungen und Abrechnung · Der Kunde zahlt, wie es ihm passt · Taoify",
        "desc": "PayPal, Stripe, Kreditkarten und Alipay sind sofort einsatzbereit. Akzeptiere Fremdwährungen, hebe RMB ab, T+7-Abrechnung, Gebühren und Einzugstermine sind transparent."
    },
    "/pricing": {
        "title": "Preise · Abonnementpakete + Staffelprovision · Taoify",
        "desc": "Shops werden nach Abonnementpaketen berechnet: Basis $15/Monat, Standard $29/Monat, Premium $59/Monat, Quartals- und Jahreszahlungen sparen. Transaktionsprovisionen variieren je nach monatlichem Umsatz, beginnend bei 3%."
    },
    "/cases": {
        "title": "Verkäufer-Beispiele · Sie tun das Gleiche · Taoify",
        "desc": "Schmuck aus Yiwu, 3C-Produkte aus Shenzhen, Kleidung aus Guangzhou und Verkäufer aus Deutschland, den USA und Frankreich – sechs Personen, sechs verschiedene Ausgangspunkte, aber die gleiche Vorgehensweise."
    },
    "/sign-up": {
        "title": "Geschäftseröffnung - Kostenloser Registrierungsprozess bei Taoify",
        "desc": "Erstelle in 10 Minuten deinen eigenen Marken-Webshop, ohne Programmierkenntnisse. Teste alle Funktionen mit einem Abonnement. Schließe den Kreislauf ab. Melde dich jetzt bei Taoify an und starte deine E-Commerce-Reise."
    },
    "/for-china-sellers": {
        "title": "Für chinesische Verkäufer · Du wählst die Produkte und setzt die Preise, den Rest übernehmen wir · Taoify",
        "desc": "Shop-Erstellung, Übersetzung, Versandkosten, Frachtausdruck, Kundenservice – der Plattform nimmt dir diese Aufgaben ab. Wähle ein Abonnement plus Staffelkommission (ab 3%)."
    },
    "/for-global-sellers": {
        "title": "Für internationale Verkäufer: Wähle Produkte von chinesischen Regalen und verkaufe sie in deinem eigenen Geschäft · Taoify",
        "desc": "Keine Lagerbestände halten, keine Vorräte aufbauen: Wähle Produkte aus der chinesischen Lieferkette, die direkt vom chinesischen Lager versendet werden, sobald der Kunde bestellt. Du verdienst den Differenzbetrag. BuyLink verwandelt auch 1688- und Taobao-Links in deine Produkte."
    },
    "/template-index": {
        "title": "Vorlagenmarkt - Professionelle Website-Themes von Taoify",
        "desc": "Professionelle Themes für jede Art von Projekt, kostenlose Branchenvorlagen, die du nach Bedarf anpassen kannst, um dein Markenimage und die Funktionalität zu personalisieren."
    },
    "/question": {
        "title": "Hilfezentrum · Finde hier zuerst Antworten auf deine Fragen · Taoify",
        "desc": "Erfahre mehr über Shoperöffnung, Gestaltung, Produktupload, Bestellverwaltung, Zahlungen, Marketing, Kontoberechtigungen – häufig gestellte Fragen sind nach Kategorien sortiert. Wenn du keine Antwort findest, erstelle einen Support-Ticket."
    },
    "/about-us": {
        "title": "Über Taoify · Was wir tun",
        "desc": "Taoify ist eine integrierte Plattform für Cross-Border-Verkäufer: Erstellen Sie Ihre Website, übersetzen, listen, organisieren Logistik, erhalten Zahlungen und führen Marketing – alles in einem Dashboard."
    },
    "/privacy-policy": {
        "title": "Datenschutzrichtlinien · Taoify",
        "desc": "Wie Taoify Ihre persönlichen Informationen sammelt, verwendet, speichert und schützt, sowie welche Rechte Sie über Ihre Daten haben."
    },
    "/terms-service": {
        "title": "Nutzungsbedingungen · Taoify",
        "desc": "Die Bedingungen und Konditionen für die Nutzung der Taoify-Plattform: Account, Geschäft, Bestellungen, Abrechnung und Verantwortlichkeiten."
    },
    "/consumer-agreement": {
        "title": "Rückgabepolitik · Taoify",
        "desc": "Erfahren Sie mehr über die Rückerstattungs- und Nachverkaufsregeln für Bestellungen auf der Taoify-Plattform: Anforderungen, Bearbeitungszeiten und Einzahlungsmethoden."
    },
    "/user-agreement": {
        "title": "Nutzungsbedingungen · Taoify",
        "desc": "Bevor Sie sich bei Taoify registrieren und nutzen, lesen Sie bitte die Anmeldebedingungen, Geschäftsrichtlinien und Plattformdienstleistungsbeschreibungen."
    }
}
